// extracted by mini-css-extract-plugin
export default {"fieldset":"StudentSense_fieldset__KB1Mc","title":"StudentSense_title__M-3fq","row":"StudentSense_row__P2WZQ","confirm":"StudentSense_confirm__fcYQL"};